import { getTenant, orgSearch } from '../helpers';
import { api } from './api';

// todo : write parse for earned skills
export function getUserEarnedSkillsAPI(username: string, callback) {
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdskillsapi.skillsOrgsSkillsUsersRetrieve(...args),
    getTenant(),
    username
  )((err, data, response) => callback(response));
}

export function getUserHighlightedSkillsAPI(username, callback) {
  const data = {
    username,
  };
  api.ibldmskills.getUserSkills(data, function (data) {
    data = parseHighlightedSkills(data);
    callback(data);
  });
}

export function addSelfReportedSkillAPI(skillData, callback) {
  api.ibldmskills.addSelfReportedSkill(skillData, function (data) {
    callback(data);
  });
}

export function addHighlightedSkillAPI(skillData, callback) {
  api.ibldmskills.addDesiredSkill(skillData, function (data) {
    callback(data);
  });
}

export function getUserSelfReportedSkillsAPI(username, callback) {
  const data = {
    username,
  };
  api.ibldmskills.getUserSelfReportedSkills(data, function (data) {
    data = parseSelfReportedSkills(data);
    callback(data);
  });
}

function parseSelfReportedSkills(data) {
  if (
    !data ||
    !data?.skills ||
    !Array.isArray(data?.skills) ||
    !data?.data ||
    !data?.data?.level
  ) {
    // Handle invalid or missing data
    return null;
  }

  return data?.skills?.map((skill, index) => {
    const { id, name } = skill;
    const levelValue = data?.data?.level[index];

    return {
      id,
      name,
      skillType: 'selfReported',
      starCount: levelValue ? parseInt(levelValue, 10) : 0,
    };
  });
}

function parseHighlightedSkills(data) {
  if (!data || !data?.skills || !Array.isArray(data?.skills)) {
    // Handle invalid or missing data
    return [];
  }

  return data?.skills?.map((skill) => {
    const { id, name } = skill;

    return {
      id,
      name,
      skillType: 'highlighted',
    };
  });
}

export function skillsSearchAPI(searchTerm, callback) {
  searchTerm = searchTerm.toLowerCase();
  if (searchTerm.length > 4) {
    const data =
      '?filter={"_index":"ibl-dm.public.dl_catalog_app_skill"}&context=' +
      searchTerm;
    orgSearch(data, function (data) {
      callback(data.results);
    });
  }
}
